import { render } from "./Accueil.vue?vue&type=template&id=73df9fdd&scoped=true&functionnal=true"
const script = {}

import "./Accueil.vue?vue&type=style&index=0&id=73df9fdd&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.35_vue@3.5.35_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73df9fdd"]])

export default __exports__